import {Injectable, signal} from '@angular/core';

export interface UploadedFile {
  id: string;
  name: string;
  size: number;
  type: string;
  preview: string | null;
  progress: number;
  status: 'uploading' | 'scanning' | 'ready' | 'error';
  error: string | null;
}

@Injectable({providedIn: 'root'})
export class ClientActionService {
  readonly verified = signal<{ lastName: string } | null>(null);
  readonly files = signal<UploadedFile[]>([]);
  readonly submittedAt = signal<Date | null>(null);
  readonly request = signal<string | null>(null);
  readonly loanNumber = signal<string | null>(null);
  readonly clientName = signal<string | null>(null);


  markVerified(lastName: string) {
    this.verified.set({lastName});
  }

  setRequest(request: string | null) {
    console.log('request from cas', request);
    this.request.set(request);
  }

  setLoanNumber(ln: string) {
    console.log('loan number', ln);
    this.loanNumber.set(ln)
  }

  setClientName(cn: string) {
    console.log('client name', cn);
    this.clientName.set(cn)
  }

  setFiles(files: UploadedFile[]) {
    this.files.set(files);
  }

  markSubmitted() {
    this.submittedAt.set(new Date());
  }

  reset() {
    this.verified.set(null);
    this.files.set([]);
    this.submittedAt.set(null);
    this.request.set(null);
  }
}
